// AiThreadChrome.jsx — feedback + thread affordance + reply on feed/surface cards

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Utilities
import { resolveThreadSummary } from 'channels/utils/threadSummaries';

// CSS
import './AiThreadChrome.css';

// Components
import MessageThreadAffordance from 'channels/components/message/MessageThreadAffordance';
import Button from 'components/button/Button';
import AiFeedbackControls from 'spaces/components/AiFeedbackControls';

const AiThreadChrome = React.memo(({
  message,
  promptText = '',
  canReplyInThread = false,
  hasUnreadReplies = false,
  onOpenThread,
  onReplyInThread,
  threadSummariesByRootKey = {},
}) => {
  // ----- CONTEXT ----- //

  const { theme } = useTheme();
  const { replyCount, lastReplyAt } = resolveThreadSummary(message, threadSummariesByRootKey);
  const showReply = canReplyInThread && !message?.parentMessageKey && replyCount <= 0;
  const showThreadAffordance = replyCount > 0;

  // ----- RENDER ----- //

  return (
    <div className="ai-thread-chrome">
      <AiFeedbackControls
        message={message}
        promptText={promptText}
      />

      {showThreadAffordance ? (
        <MessageThreadAffordance
          replyCount={replyCount}
          lastReplyAt={lastReplyAt}
          hasUnreadReplies={hasUnreadReplies}
          onOpenThread={() => onOpenThread?.(message?.key)}
        />
      ) : null}

      {/* REPLY */}
      {showReply ? (
        <Button
          className="ai-thread-chrome__reply"
          title="Reply in thread"
          iconKey="chat"
          iconColor={theme.foregroundMuted}
          backgroundColor="transparent"
          hoverForegroundColor={theme.foreground}
          iconSize="14"
          height="28px"
          width="28px"
          padding="4px"
          borderRadius="6px"
          onClick={() => onReplyInThread?.(message?.key)}
        />
      ) : null}
    </div>
  );
});

// Dev Tools
AiThreadChrome.displayName = 'AiThreadChrome';

export default AiThreadChrome;
